import React, { useState, useEffect, useRef } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link, useNavigate } from 'react-router-dom';
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "select2";
import Breadcrumbs from '../components/Breadcrumbs';
import TitleTextButton from '../modules/TitleTextButton';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import Formulare from '../modules/Formulare';
import Header_3 from '../headers/Header_3';
import Header_2 from '../headers/Header_2';
import { Turnstile } from "@marsidev/react-turnstile";
import { set } from 'date-fns';
import SEO from '../components/Seo';

export const WohnenFormulare = () => {

    const navigate = useNavigate();

    useEffect(() => {
        $(".select2").select2();
    }, []);

    const fileRef = useRef(null);
    const [fileName, setFileName] = useState("");

    const handleClick = () => {
        fileRef.current.click();
    };

    // const handleChange = (e) => {
    //     if (e.target.files.length > 0) {
    //         setFileName(e.target.files[0].name);
    //     }
    // };

    useEffect(() => {
        const equalHeight = () => {
            // 👉 H4 elements
            const headings = document.querySelectorAll(
                ".dokumente_slider .item_inner h4"
            );

            let maxH4 = 0;
            headings.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });
            headings.forEach((el) => {
                el.style.height = maxH4 + "px";
            });

            // 👉 P elements
            const paragraphs = document.querySelectorAll(
                ".dokumente_slider .item_inner p"
            );

            let maxP = 0;
            paragraphs.forEach((el) => {
                el.style.height = "auto";
                maxP = Math.max(maxP, el.offsetHeight);
            });
            paragraphs.forEach((el) => {
                el.style.height = maxP + "px";
            });
        };

        // run on load
        setTimeout(equalHeight, 800);

        // run on resize
        window.addEventListener("resize", equalHeight);

        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);


    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);

    const [metaData, setMetaData] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/formulare-page?populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.formulare-reglemente-dokumente][populate][formulares][populate][PDF][populate][PDF][populate]=*&populate[Modul][on][modules.formulare-reglemente-dokumente][populate][formulares][populate][Button][populate]=*&populate[Modul][on][modules.formulare-reglemente-dokumente][populate][formulares][populate][icon][populate]=true&populate[Metadaten]=*");



            // &populate[Modul][on][modules.formulare-reglemente-dokumente][populate][Titel_Text]=*
            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][siedlungen_kategorien][populate]=*

            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true


            // populate[Modul][on][modules.news][populate][Kurztitel_Titel_Text_Button][populate]=*
            // populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*

            const data = await response.json();
            console.log(data?.data?.Modul);

            if (data.data) {
                setPageData(data.data);
                setMetaData(data.data?.Metadaten);
                setModules(data?.data?.Modul);
                setHeaderModules(data?.data?.Bannerbereich);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
    }, [])


    // ================= STATES =================

    const [formData, setFormData] = useState({
        vorname: "",
        nachname: "",
        firma: "",
        plz: "",
        ort: "",
        strasse: "",
        telefon: "",
        email: "",
        category: "",
        werkstatt: "",
        message: "",
    });

    const [errors, setErrors] = useState({});

    // ================= HANDLE FORM =================

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // REMOVE ERROR ON CHANGE
        setErrors((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            setFileName(file.name);
        }
    };


    // ================= SELECT2 =================

    useEffect(() => {
        $(".select2").each(function () {
            const $this = $(this);

            $this.select2();

            $this.on("change", function () {
                const name = $(this).attr("name");
                const value = $(this).val();

                console.log("Changed:", name, value);

                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .removeClass("warning-border shake");

                if (name in formData) {
                    setFormData((prev) => ({
                        ...prev,
                        [name]: value,
                    }));
                }
            });
        });

        return () => {
            const selects = $(".select2");
            selects.each(function () {
                const $el = $(this);

                // destroy only if initialized
                if ($el.data("select2")) {
                    console.log("Destroying select2 for", $el.attr("name"));
                    $el.select2("destroy");
                }
            });
        };
    }, []);

    useEffect(() => {
        $(".select2").each(function () {
            const name = $(this).attr("name");

            console.log("Validating select:", name, formData[name], errors[name]);

            if (errors[name] && formData[name].trim() === "") {
                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .addClass("warning-border shake");
            } else {
                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .removeClass("warning-border shake");
            }
        });
    }, [errors]);


    // ================= SUBMIT =================
    const [captchaToken, setCaptchaToken] = useState("");
    const [captchaError, setCaptchaError] = useState(false);


    const validateForm = () => {
        let newErrors = {};

        const requiredFields = [
            "vorname",
            "nachname",
            "plz",
            "ort",
            "strasse",
            "telefon",
            "email",
            "category",
            "werkstatt",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field] || formData[field].trim() === "") {
                newErrors[field] = true;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log("Submitting form with data:", formData);

        const isValid = validateForm();

        if (!isValid) {
            return;
        }

        if (!captchaToken) {
            setCaptchaError(true);
            return;
        }

        try {
            setIsSubmitting(true);

            const submitData = new FormData();

            // append text fields
            Object.keys(formData).forEach((key) => {
                submitData.append(key, formData[key]);
            });

            // append file
            if (fileRef.current.files[0]) {
                submitData.append("file", fileRef.current.files[0]);
            }

            const response = await fetch(
                `${process.env.REACT_APP_FRONTEND_URL}api/submit-formulare-form?pageTitle=Reparaturmeldung`,
                {
                    method: "POST",
                    body: submitData,
                }
            );

            const data = await response.json();

            console.log(data);

            if (data?.success) {

                // RESET
                setFormData({
                    vorname: "",
                    nachname: "",
                    firma: "",
                    plz: "",
                    ort: "",
                    strasse: "",
                    telefon: "",
                    email: "",
                    category: "",
                    werkstatt: "",
                    message: "",
                });

                setFileName("");

                navigate("/vielen-dank");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-2-text-bild" && (
                            <Header_2 module={module} isLoading={isLoading} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-wohnen" activePage="wohnen" bgGray={true} />
                        )}
                    </React.Fragment>
                ))
            )}


            {!isLoading ? (
                modules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "modules.short-titel-titel-text-button" &&
                            <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    {/* <div className='subtitle'><img src='https://backend.bgzurlinden.ch/uploads/logo_icon_981b559742.svg' alt='#' /> zurlinden</div> */}
                                    {/* <div className='page-breadcrumb pb-5'>
                                        <Breadcrumbs />
                                    </div> */}
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                </div>
                            </section>
                        }
                        {/* {module.__component === "modules.carousel-bild-re-text" &&
                            <section className={`pt-pb-10 sec-green-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} equalCol={false} />
                                </div>
                            </section>} */}
                        {module.__component === "modules.formulare-reglemente-dokumente" &&
                            <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    {/* <DokumenteSlider formulare={module?.formulares} /> */}
                                    <Formulare formulare={module?.formulares} />
                                </div>
                            </section>}
                    </React.Fragment>
                ))
            ) : (
                <>
                    <section className={`banner_sec inner_banner wohnen-banner position-relative`}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                                    <h1>{<Skeleton count={1} />}</h1>
                                    <p>{<Skeleton count={3} />}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className={`pt-pb-10 sec-orange-color`}>
                        <div className='container'>
                            <div className='title-text-button-module'>
                                {/* {shortTitle && <div className='subtitle'>{shortTitle}</div>} */}
                                <div className='row'>
                                    <div className='col-lg-5 title-col'>
                                        {/* {title && <h2 className='text-black mb-lg-4 mb-2'>{title}</h2>} */}
                                        <h2>{<Skeleton count={1} />}</h2>
                                    </div>
                                    <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                                        <p>{<Skeleton count={3} />}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}

        </div>
    )
}